import { TextField } from "@mui/material";
import { PropTypes } from 'prop-types';
import { useEffect } from "react";
import { justNumbers } from "../utils/PhoneNumber";

const LyftSettingsInput = ({initialValue, inputValue, onChange, handleEdit, editMode, maxLength, type}) => {
  return (
    <TextField 
      variant="outlined"
      size="small"
      className="w-full"
      value={editMode ? inputValue : initialValue}
      focused={editMode}
      onChange={
        type === 'number'
        ? (e) => onChange(justNumbers(e.target.value))
        : (e) => onChange(e.target.value)
      }
      onClick={() => { !editMode && handleEdit() }}
      InputProps={{
        className: 'text-sm p-0',
        readOnly: !editMode
      }}
      inputProps={{
        maxLength: maxLength
      }}
    />
  )
}

LyftSettingsInput.propTypes = {
  initialValue: PropTypes.string,
  inputValue: PropTypes.string,
  onChange: PropTypes.func,
  handleEdit: PropTypes.func,
  editMode: PropTypes.bool,
  maxLength: PropTypes.number,
  type: PropTypes.string
} 

LyftSettingsInput.defaultProps = {
  initialValue: '',
  inputValue: '',
  onChange: () => {},
  handleEdit: () => {},
  editMode: false,
  maxLength: 120,
  type: ''
}

export default LyftSettingsInput;